// react
import React from "react";

// react-router-dom
import { useNavigate, useLocation } from "react-router-dom";

// context
import { UserAuth } from "context/AuthContext";

// react-i18next
import { useTranslation } from "react-i18next";

// react-flagkit
import Flag from "react-flagkit";

// @mui
import { useTheme, useMediaQuery, Link, Box, Grid, AppBar, Toolbar, Tooltip, Select, MenuItem, IconButton } from "@mui/material";
import { Login as LoginIcon } from "@mui/icons-material";

// A ---------------------------------------------------------------------- M

const Logo = () => (
  <Link href="/" sx={{ display: "flex" }}>
    <Box
      component="img"
      src="/logo/trust-conserve/logo.png"
      alt="Company logo"
      sx={{
        maxHeight: 30,
        transform: "scale(3.5)",
        transformOrigin: "left",
      }}
    />
  </Link>
);

const LanguageOption = ({ country, label }) => (
  <Box display="flex" alignItems="center">
    <Flag country={country} style={{ marginRight: 8 }} />
    {label}
  </Box>
);

const TrustConserveDefault = ({ children }) => {
  const { language, setLanguage } = UserAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handleLanguageChange = (e) => setLanguage(e.target.value);
  const handleSignIn = () => navigate("/signin");

  const isDefaultable = location.pathname === "/signin" || location.pathname === "/reset-password";
  const gridItemStyle = isDefaultable ? {} : isMobile ? { p: "3%" } : { p: "1.5%" };

  return (
    <Grid container>
      <Grid item xs={12}>
        <AppBar
          position="fixed"
          elevation={0}
          sx={{
            zIndex: theme.zIndex.drawer + 1,
            background: "linear-gradient(180deg, rgba(13,71,161,0.9) 0%, rgba(10,53,122,0.95) 100%)",
            backdropFilter: "blur(10px)",
            borderBottom: "1px solid rgba(255,255,255,0.08)",
            boxShadow: "0 2px 8px rgba(0,0,0,0.4)",
          }}
        >
          <Toolbar variant="regular">
            <Logo />
            <Box sx={{ flexGrow: 1 }} />
            <Select
              value={language}
              onChange={handleLanguageChange}
              variant="standard"
              disableUnderline
              sx={{
                color: "#ffffff",
                "& .MuiSvgIcon-root": { color: "#ffffff" },
              }}
            >
              <MenuItem value="it">
                <LanguageOption country="IT" label="IT" />
              </MenuItem>
              <MenuItem value="en">
                <LanguageOption country="GB" label="EN" />
              </MenuItem>
            </Select>

            {!isDefaultable && (
              <Tooltip title={t("sign_in")} placement="top">
                <IconButton onClick={handleSignIn}>
                  <LoginIcon />
                </IconButton>
              </Tooltip>
            )}
          </Toolbar>
        </AppBar>

        {!isDefaultable && <Toolbar />}
      </Grid>
      <Grid item xs={12} sx={gridItemStyle}>
        {children}
      </Grid>
    </Grid>
  );
};

export default TrustConserveDefault;
